export default {
  // 页面标题
  'finance.budgetRequest.headerTitle': 'Budget Request Management',

  // 表格列标题
  'finance.budgetRequest.column.code': 'Request Code',
  'finance.budgetRequest.column.name': 'Request Name',
  'finance.budgetRequest.column.billingPeriod': 'Billing Period',
  'finance.budgetRequest.column.projectName': 'Project Name',
  'finance.budgetRequest.column.budgetType': 'Budget Type',
  'finance.budgetRequest.column.amount': 'Request Amount',
  'finance.budgetRequest.column.applyUser': 'Applicant',
  'finance.budgetRequest.column.payeeUser': 'Payee',
  'finance.budgetRequest.column.status': 'Status',
  'finance.budgetRequest.column.applyRemark': 'Application Remark',
  'finance.budgetRequest.column.remarks': 'Remarks',

  // 状态标签
  'finance.budgetRequest.status.draft': 'Draft',
  'finance.budgetRequest.status.pending': 'Pending',
  'finance.budgetRequest.status.approved': 'Approved',
  'finance.budgetRequest.status.rejected': 'Rejected',

  // 按钮操作
  'finance.budgetRequest.action.create': 'Create Budget Request',
  'finance.budgetRequest.action.submitAudit': 'Submit Audit',
  'finance.budgetRequest.action.upload': 'Click to upload file',

  // 确认对话框
  'finance.budgetRequest.confirm.delete': 'Are you sure you want to delete this budget request?',
  'finance.budgetRequest.confirm.batchDelete': 'Are you sure you want to batch delete the selected budget requests?',

  // 消息提示
  'finance.budgetRequest.message.getDetailFailed': 'Failed to get budget request details',
  'finance.budgetRequest.message.generateCodeFailed': 'Failed to generate request code',
  'finance.budgetRequest.message.selectForAudit': 'Please select budget requests to submit for audit',
  'finance.budgetRequest.message.submitAudit.success': 'Submit audit successful',
  'finance.budgetRequest.message.submitAudit.failed': 'Submit audit failed',
  'finance.budgetRequest.message.update.success': 'Update budget request successful',
  'finance.budgetRequest.message.update.failed': 'Update budget request failed',
  'finance.budgetRequest.message.create.success': 'Create budget request successful',
  'finance.budgetRequest.message.create.failed': 'Create budget request failed',

  // 详情标签
  'finance.budgetRequest.label.code': 'Request Code',
  'finance.budgetRequest.label.name': 'Request Name',
  'finance.budgetRequest.label.billingPeriod': 'Billing Period',
  'finance.budgetRequest.label.projectName': 'Project Name',
  'finance.budgetRequest.label.budgetType': 'Budget Type',
  'finance.budgetRequest.label.amount': 'Request Amount',
  'finance.budgetRequest.label.applyUser': 'Applicant',
  'finance.budgetRequest.label.payeeUser': 'Payee',
  'finance.budgetRequest.label.status': 'Status',
  'finance.budgetRequest.label.applyRemark': 'Application Remark',
  'finance.budgetRequest.label.attachment': 'Attachment File',
  'finance.budgetRequest.label.remarks': 'Remarks',

  // 表单字段标签
  'finance.budgetRequest.form.code.label': 'Request Code',
  'finance.budgetRequest.form.code.placeholder': 'Please enter request code',
  'finance.budgetRequest.form.code.required': 'Please enter request code',
  'finance.budgetRequest.form.code.max': 'Request code length cannot exceed 100 characters',

  'finance.budgetRequest.form.name.label': 'Request Name',
  'finance.budgetRequest.form.name.placeholder': 'Please enter request name',
  'finance.budgetRequest.form.name.required': 'Request name is required',
  'finance.budgetRequest.form.name.max': 'Request name length cannot exceed 100 characters',

  'finance.budgetRequest.form.billingPeriod.label': 'Billing Period',
  'finance.budgetRequest.form.billingPeriod.placeholder': 'Please select billing period',
  'finance.budgetRequest.form.billingPeriod.required': 'Billing period is required',

  'finance.budgetRequest.form.projectName.label': 'Project Name',
  'finance.budgetRequest.form.projectName.placeholder': 'Please select project name',

  'finance.budgetRequest.form.budgetType.label': 'Budget Type',
  'finance.budgetRequest.form.budgetType.placeholder': 'Please select budget type',
  'finance.budgetRequest.form.budgetType.required': 'Please select budget type',

  'finance.budgetRequest.form.amount.label': 'Request Amount',
  'finance.budgetRequest.form.amount.placeholder': 'Please enter request amount',
  'finance.budgetRequest.form.amount.required': 'Please enter request amount',
  'finance.budgetRequest.form.amount.min': 'Amount cannot be less than 0',

  'finance.budgetRequest.form.applyUser.label': 'Applicant',
  'finance.budgetRequest.form.applyUser.placeholder': 'Please enter applicant name',
  'finance.budgetRequest.form.applyUser.max': 'Applicant name cannot exceed 100 characters',

  'finance.budgetRequest.form.payeeUser.label': 'Payee',
  'finance.budgetRequest.form.payeeUser.placeholder': 'Please enter payee name',
  'finance.budgetRequest.form.payeeUser.max': 'Payee name cannot exceed 100 characters',

  'finance.budgetRequest.form.applyRemark.label': 'Application Remark',
  'finance.budgetRequest.form.applyRemark.placeholder': 'Please enter application remark',
  'finance.budgetRequest.form.applyRemark.max': 'Application remark length cannot exceed 500 characters',

  'finance.budgetRequest.form.remarks.label': 'Remarks',
  'finance.budgetRequest.form.remarks.placeholder': 'Please enter remarks',
  'finance.budgetRequest.form.remarks.max': 'Remarks length cannot exceed 500 characters',

  'finance.budgetRequest.form.bankStatement.label': 'Bank Statement',
  'finance.budgetRequest.form.bankStatement.placeholder': 'Please search and select bank statement',

  'finance.budgetRequest.form.auditName.label': 'Audit Name',
  'finance.budgetRequest.form.auditName.placeholder': 'Please enter audit name',
  'finance.budgetRequest.form.auditName.required': 'Please enter audit name',

  'finance.budgetRequest.form.submitRemark.label': 'Submit Remark',
  'finance.budgetRequest.form.submitRemark.placeholder': 'Please enter submit remark (optional)',

  // 弹窗和抽屉标题
  'finance.budgetRequest.modal.detailTitle': 'Budget Request Details',
  'finance.budgetRequest.modal.submitAuditTitle': 'Submit Audit',
  'finance.budgetRequest.drawer.title.create': 'Create Budget Request',
  'finance.budgetRequest.drawer.title.edit': 'Edit Budget Request',

  // 分区标题
  'finance.budgetRequest.section.basic': 'Basic Information',
  'finance.budgetRequest.section.apply': 'Application Information',
  'finance.budgetRequest.section.attachment': 'Attachment Information',
  'finance.budgetRequest.section.other': 'Other Information',
  'finance.budgetRequest.section.auditRecords': 'Audit Records',
  'finance.budgetRequest.section.bankStatement': 'Related Bank Statement',

  // 审核相关
  'finance.budgetRequest.audit.defaultName': 'Budget Request Audit ({count} items)',
  'finance.budgetRequest.selectedBills': 'Selected budget requests list (total {count} items)',
  'finance.budgetRequest.loading': 'Loading...',
  'finance.budgetRequest.empty.auditRecords': 'No audit records yet',
  'finance.budgetRequest.message.bankStatementNotFound': 'Failed to load bank statement information',

  // 操作相关
  'finance.budgetRequest.action.downloadOriginal': 'Download Original File',
};
